<ng-container *ngIf="slides && slides?.length  && (slides?.length > 0)">
  <ul class="list-group ui-sortable"  cdkDropList (cdkDropListDropped)="dropOption($event)">
    <li class="list-group-item" *ngFor="let slide of slides.controls;index as i;" cdkDragLockAxis="y" cdkDrag>
      <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
      <div class="preset-option d-flex">
        <div class="preset-option__drag-and-drop d-flex align-items-center justify-content-center">
          <app-icon-menu></app-icon-menu>
        </div>
        <div class="preset-option__content d-flex align-items-center">
          <div class="preset-option__number">{{ i + 1 }}.</div>
          <img [src]="getPresetOptionImageUrl(slide)" alt="thumbnail" class="preset-option__image">
          <div class="preset-option__container d-flex flex-column">
          </div>
          <div class="preset-option__actions">
            <div class="preset-option__action" (click)="removeOption(i)">
              <app-icon-trash></app-icon-trash>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</ng-container>

